import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder, FormGroup} from "@angular/forms";
import {ApplyFormService} from "../../../shared/services/apply-form.service";

@Component({
    selector: 'app-international-admissions',
    templateUrl: './international-admissions.component.html',
    styleUrls: ['./international-admissions.component.scss']
})
export class InternationalAdmissionsComponent implements OnInit {
    pageTitle: any;
    activeIndex: number | null = null;
    searchForm: FormGroup = new FormGroup({});

    admissionFaqs = [
        {
            question: "The course offered by ARNI University is recognized/approved by government bodies?",
            answer: "Yes, ARNI University is recognized by government bodies such as UGC, AICTE, PCI, HP-PERC, & DIRECTORATE OF HIGHER EDUCATION. Moreover, it is also approved by BCI, ISO, IPC, NCC, and NSS."
        },
        {
            question: "What are the courses/programs offered by ARNI University?",
            answer: "ARNI University is one of the fastest-growing and reputable universities in North India. It offers a range of courses from engineering to law, health science, agricultural, basic science, pharmacy, business management, mass communication and journalism, hotel management, and sports."
        },
        {
            question: "Do we need to pay a capitation fee?",
            answer: "No, we do not entertain any kind of capitation fee. Students who are shortlisted at ARNI need to pay the tuition and other charges as mentioned in the course fee section only."
        },
        {
            question: "What is the duration of the courses?",
            answer: "At ARNI, we offer a wide range of undergraduate, postgraduate, doctoral, and diploma courses. The duration of the course depends on the particular specializations. Usually, the diplomas are 6 months long, UG courses is 3-4 years long, while PG courses last for 2 years."
        },
        {
            question: "What is the eligibility criteria for international applicants?",
            answer: "International students must have a minimum of 50% marks in their last qualifying examination. For postgraduate programs like M.Tech, a bachelor’s degree in a relevant field with at least 55% marks is required."
        },
        {
            question: "How can international students apply for admission at ARNI University?",
            answer: "To apply, international students must visit www.arniuniversity.edu.in, choose their desired course, fill out the online application form, and upload the required documents such as academic transcripts, certificates, and passport copies."
        },
        {
            question: "Does ARNI University offer any support to international students after admission?",
            answer: "Yes, ARNI University provides personalized support through a dedicated international admissions office. The team assists students with enrollment, accommodation, integration into campus life, and more to ensure a smooth transition."
        },
        {
            question: "Are degrees from ARNI University recognized globally?",
            answer: "Yes, ARNI University is approved by the University Grants Commission (UGC). Degrees awarded by the university are recognized nationally and internationally, enabling students to pursue further education or employment globally."
        },
        {
            question: "What kind of placement support does ARNI University offer?",
            answer: "ARNI has a dedicated placement cell that helps students with internships, industry connections, job opportunities, resume building, and interview preparation to enhance employability."
        },
        {
            question: "How can I contact ARNI University for more information about international admissions?",
            answer: "For any queries, international students can reach out via:\nEmail: international.admission@arniuniversity.edu.in\nHelpline: +91-9418601409"
        }
    ];

    courseFee = [
        {
            course_name: "Bachelor of Technology (Computer Science & Engineering)",
            duration: "4 Years",
            scholarship_availability: "20% Every Year",
            fee_per_year: 4000
        },
        {
            course_name: "B.Tech Electronics & Computer Engineering",
            duration: "4 Years",
            scholarship_availability: "20% Every Year",
            fee_per_year: 4000
        },
        {
            course_name: "B.Tech (CSE) - Artificial Intelligence for IoT Applications in association with Aeris Communications",
            duration: "4 Years",
            scholarship_availability: "20% Every Year",
            fee_per_year: 4000
        },
        {
            course_name: "B.Tech (EEE) - Electric Vehicle Technology",
            duration: "4 Years",
            scholarship_availability: "20% Every Year",
            fee_per_year: 4000
        },
        {
            course_name: "Diploma in Pharmacy",
            duration: "2 Years",
            scholarship_availability: "0",
            fee_per_year: 2500
        }
    ];
    courses: any[] = []
    pcbData: any[] = []
    branches: any[] = []
    filteredCourses: any[] = []
    filterCoursesForm: FormGroup = new FormGroup({});


    constructor(private route: ActivatedRoute,
                private router: Router,
                private applyFormService: ApplyFormService,
                private fb: FormBuilder,) {
        this.route.data.subscribe(params => {
            this.pageTitle = params['title'];
        })
    }

    ngOnInit(): void {
        this.refresh()
    }

    refresh() {
        this.searchForm = this.fb.group({
            search_key: [''],
        })
        this.getPcb()

    }

    goTo(section: string) {
        this.router.navigateByUrl(section);
    }

    toggleAccordion(index: number): void {
        if (this.activeIndex === index) {
            this.activeIndex = null;
        } else {
            this.activeIndex = index;
        }
    }


    toggleFeeType(type: 'semester' | 'yearly', course: any) {
        course.fee_type = type
        // this.selectedFeeType = type;
    }

    getPcb(): void {
        this.applyFormService.pcb_mapping().subscribe(data => {
            this.getCourses(data.data)
        })
    }

    getCourses(data: any) {
        let allCourses = data
            .filter((item: any) =>
                item?.course?.id &&
                Array.isArray(item.fees) &&
                item.fees.some((fee: any) => +fee.session_id === 17)
            )
            .map((item: any) => ({
                ...item,
                result_type: item.result_type,
                fee_type: item.result_type === 'SEMESTER' ? 'semester' : 'yearly',
                fees: item.fees.filter((fee: any) => +fee.session_id === 17)
            }));

        allCourses.forEach((course: any) => {
            let exits = this.courses.find((item: any) => +course.course.id === +item.id)
            if (!exits) {
                this.courses.push({
                    id: course.course.id,
                    name: course.course.name,
                })
            }
        })

        allCourses.forEach((course: any) => {
            course.semester_fee = []
            for (let fee of course.fees) {
                fee.total_fee = (+fee?.tuition_fee || 0)
            }

            for (let fee of course.fees) {
                if (+fee?.year === 1) {
                    course.semester_fee.push({semester: 1, fee: fee.total_fee / 2})
                    course.semester_fee.push({semester: 2, fee: fee.total_fee / 2})
                }

                if (+fee?.year === 2) {
                    course.semester_fee.push({semester: 3, fee: fee.total_fee / 2})
                    course.semester_fee.push({semester: 4, fee: fee.total_fee / 2})
                }

                if (+fee?.year === 3) {
                    course.semester_fee.push({semester: 5, fee: fee.total_fee / 2})
                    course.semester_fee.push({semester: 6, fee: fee.total_fee / 2})
                }

                if (+fee?.year === 4) {
                    course.semester_fee.push({semester: 7, fee: fee.total_fee / 2})
                    course.semester_fee.push({semester: 8, fee: fee.total_fee / 2})
                }

                if (+fee?.year === 5) {
                    course.semester_fee.push({semester: 9, fee: fee.total_fee / 2})
                    course.semester_fee.push({semester: 10, fee: fee.total_fee / 2})
                }

                if (+fee?.year === 6) {
                    course.semester_fee.push({semester: 11, fee: fee.total_fee / 2})
                    course.semester_fee.push({semester: 12, fee: fee.total_fee / 2})
                }

                if (+fee?.year === 7) {
                    course.semester_fee.push({semester: 13, fee: fee.total_fee / 2})
                    course.semester_fee.push({semester: 14, fee: fee.total_fee / 2})
                }

                if (+fee?.year === 8) {
                    course.semester_fee.push({semester: 15, fee: fee.total_fee / 2})
                    course.semester_fee.push({semester: 16, fee: fee.total_fee / 2})
                }
            }
        })

        this.pcbData = allCourses;
        this.filteredCourses = this.pcbData
    }

    getBranches() {
        let courseId = this.filterCoursesForm && this.filterCoursesForm.getRawValue() && this.filterCoursesForm.getRawValue().course_id || ''
        this.branches = []
        if (courseId) {
            this.branches = this.pcbData.filter((item: any) => +item.course.id === +courseId)
            if (this.branches.length > 0) {
                this.filteredCourses = this.branches
            } else {
                this.filteredCourses = this.pcbData
            }
        } else {
            this.filteredCourses = this.pcbData
        }
    }

    filterBranches() {
        let courseId = this.filterCoursesForm && this.filterCoursesForm.getRawValue() && this.filterCoursesForm.getRawValue().course_id || '';
        let branchId = this.filterCoursesForm && this.filterCoursesForm.getRawValue() && this.filterCoursesForm.getRawValue().branch_id || ''
        this.filteredCourses = []

        if (branchId) {
            if (branchId === 'general') {
                this.filteredCourses = this.pcbData.filter((item: any) => item?.branch === null && item.course?.id === +courseId)
            } else {
                this.filteredCourses = this.pcbData.filter((item: any) => item?.branch?.id === +branchId && item.course?.id === +courseId)
            }
        } else {
            this.filteredCourses = this.pcbData.filter((item: any) => item.course?.id === +courseId)
        }
    }


}


